import alerts from './alerts.module'
export default alerts
